<template>
  <div id="app" class="container">
    <router-view />
  </div>
</template>

<script>
// import './assets/app.scss'
import { USER_CONFIG } from "./config/UserConfig";
export default {
  name: "App",
  beforeCreate() {
    const { apelidoCliente, codigoCliente } = this.$route.params;
    const valorBuscaCliente = apelidoCliente || codigoCliente;
    if (
      valorBuscaCliente &&
      valorBuscaCliente != "undefined" &&
      valorBuscaCliente.length
    ) {
      this.$store.dispatch("carregarCliente", valorBuscaCliente);

      //verificar se tem participante no cache do localstorage
      this.$store.dispatch("obterPessoaPreCarregada");
    } else {
      if (this.cliente && this.cliente.apelidoUnico)
        this.$router.push({
          name: "LoginPage",
          params: { apelidoCliente: this.cliente.apelidoUnico },
        });
    }
  },
  mounted() {
    //this.$loading({loading:true})
  },
  computed: {
    cliente() {
      return storageService.getJsonItem(USER_CONFIG.clienteFormulario);
    },
  },
};
</script>

<style>
/* @import url('./assets/style.css'); */
</style>



// WEBPACK FOOTER //
// src/App.vue